import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { useTheme }, "@mui/material/Box": Box, "@mui/material/OutlinedInput": OutlinedInput, "@mui/material/InputLabel": InputLabel, "@mui/material/MenuItem": MenuItem, "@mui/material/FormControl": FormControl, "@mui/material/Select": Select, "@mui/material/Chip": Chip } } });
export default ClientProvider;
